import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Display-only formatter for a stored phone number: a US/NANP number renders as
// "(xxx) xxx-xxxx", any other parseable number renders with its country code
// (e.g. "+44 20 7183 8750"). Anything that will not parse is returned as-is so
// an unexpected value is still shown rather than dropped.
export function formatPhoneUsDisplay(value) {
    if (!value) {
        return '';
    }

    // isPossible() gates on length only, not on the region's assigned prefixes,
    // so a well-formed number still formats even when the exchange is unassigned
    // (e.g. the fictional 555 range) - the right test for a display formatter.
    const parsed = parsePhoneNumberFromString(value, 'US');
    if (!parsed || !parsed.isPossible()) {
        return value;
    }

    const isNanp = parsed.country === 'US' || parsed.countryCallingCode === '1';

    return isNanp ? parsed.formatNational() : parsed.formatInternational();
}

export default formatPhoneUsDisplay;
